<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "ydtBillCode":"20180101101021224433",
                "outerTopBillCode":"20180101101021223322",
                "outerBillCode":"201801011010212241113",
                "payStatus":1,
                "payStatusDesc":"ok",
                "paySuccessTime":"20180101101021",
                "attach":"{}",
                "totalPayValue":5,
                "realPayValue":5,
                "payMode":4,
                "payModeRemark":"微信支付",
                "payOrigin":10,
                "payOriginRemark":"独立H5",
                "toParkAmount":5,
                "toPlatformAmount":0,
                "couponList":[]
           },
            responseCode: {"data":{},"message":"业务成功","resultCode":0,"status":1}	,
            infoData: {
                explain: "智慧停车开放平台主动上报账单信息到第三方接入系统",
                urlPattern: "第三方提供基础URL+/notifyPayInfoWithoutPayOrder",
                precondition: "配合调用ydtw扫码支付接口使用",
                pattern: "第三方提供接口, 智慧停车开放平台主动请求第三方",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'ydtBillCode', info2: '是', info3: 'String', info4: '智慧停车支付流水号' },
                        { info1: 'outerTopBillCode', info2: '是', info3: 'String', info4: '第三方业务流水号，如停车流水号(一次业务可能多次支付)，长度20以内' },
                        { info1: 'outerBillCode', info2: '是', info3: 'String', info4: '第三方支付流水号，长度20以内' },
                        { info1: 'payStatus', info2: '是', info3: 'int', info4: '支付状态，0失败，1成功' },
                        { info1: 'payStatusDesc', info2: '否', info3: 'String', info4: '支付状态说明' }
                        ]
                },{
                    titleName: '只有payStatus=1支付成功后才会有以下参数',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'paySuccessTime', info2: '是', info3: 'String', info4: '支付成功时间，格式为yyyyMMddHHmmss' },
                        { info1: 'attach', info2: '是', info3: 'JSONObject', info4: '支付成功通知地址，支付成功将通知该地址' },
                        { info1: 'totalPayValue', info2: '是', info3: 'decimal', info4: '支付金额，单位元' },
                        { info1: 'realPayValue', info2: '是', info3: 'decimal', info4: '用户实付金额' },
                        { info1: 'payMode', info2: '是', info3: 'int', info4: '支付方式，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'payModeRemark', info2: '是', info3: 'String', info4: '缴费方式备注' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                        { info1: 'couponList', info2: '是', info3: 'JSONArray', info4: '优惠列表' },
                        ]
                },{
                    titleName: 'couponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponType', info2: '是', info3: 'String', info4: '优惠类型，跟优惠来源相关' },
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称' },
                        { info1: 'couponValue', info2: '是', info3: 'decimal', info4: '实际的抵扣金额' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠编码' },
                        { info1: 'reliefType', info2: '是', info3: 'int', info4: '减免类型(0:全面,1:金额扣减,费减免固定金额结算,2:金额折扣券,3:金额固定值券,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算)' },
                        { info1: 'faceValue', info2: '是', info3: 'String', info4: '面值' },
                        { info1: 'couponOrigin', info2: '是', info3: 'int', info4: '0停车场 1智慧停车 2第三方' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/ydtPay/notifyPayInfoWithoutPayOrder.vue